// Shared types across all domains
export const PublishingPlatforms = {
  "Đăng bài trên các nền tảng Mạng xã hội (Facebook, Zalo,…)": 1,
  "Đăng bài PR lên các trang website (báo chí, tin tức, blog…)": 2,
  "Tạo nội dung Email Marketing": 4,
};

// Re-export post settings from postSettings.js for convenience
export {
  POST_LENGTHS,
  POST_STYLES,
  DEFAULT_POST_LENGTH,
  DEFAULT_POST_STYLES,
} from "./postSettings";
